<div style="position: absolute;top:-1000px;">
  <span *ngFor="let lang of AVAILABLE_LANGS" (click)="translate.use(lang)" id="{{'forceLanguage-'+lang}}"></span>
</div>

<app-loader-overlay></app-loader-overlay>
<router-outlet></router-outlet>
